<template>
    <div> 
        <v-switch class="ml-2" label="Treeview" v-model="useTreeView"></v-switch>       
        <v-treeview v-if="useTreeView" :items="items"></v-treeview>
        <gat-grid v-else :items="gridItems" :columns="gridColumns">    
            <template slot="customCell" slot-scope="slotProps" >                
                <v-checkbox v-if="!slotProps.item.isTransaction" class="gridCategory" :class="'indent_'+slotProps.item.indent" v-model="expandedCategories[slotProps.item.id]" :label="slotProps.item.text"></v-checkbox>                
                <span v-else :class="'indent_'+slotProps.item.indent">{{slotProps.item.date}} : {{slotProps.item.text}}<v-btn flat color="primary" @click="manage(slotProps.item.transaction)">manage</v-btn></span>                                
            </template>
        </gat-grid>
    </div>
</template>

<script>
    import GatUtils from '@/GatComponents/GatUtils.js';
    import GatGrid from '@/GatComponents/GatGrid.vue';
    import moment from 'moment';
    export default {
        name: 'AmountsPerCategory',
        props: ['value'],
        components: {GatGrid},
        data: function() {
            return	{
                useTreeView : false,
                expandedCategories:{},
                gridColumns :[ 
                    {header:"Category",customSlot:true},                          
                    {header:"Amount",field:"amount"},                                                                       
                ],
            }
        },


        created(){
        },

        watch:{
        },

        computed:{
            

            items(){
                let result = [];
                let rootCats = this.findUsedRootCateories(this.value);
                rootCats.map(rootCat=>{
                    let node = this.makeTreeNode(rootCat);
                    result.push(node);
                })         
                this.value.map(trans=>{
                    this.addTransactionToTree(trans,result);
                }); 
                return result;
            },
            
            
            gridItems(){
                let result = [];
                let tree = this.items;
                tree.map(rootNode=>{
                    this.addNodeToGridItems(rootNode,result,0);                    
                });
                return result;
            },
        },

        methods:{            
            addNodeByCategoryId(catId,tree){               
                let category = this.getCategoryFromId(catId);      
                if(category){
                    let parentNode = this.findNodeByCategoryId(category.CAT_PARENT_ID,tree);
                    if(parentNode){
                        let node = this.makeTreeNode(category);                        
                        parentNode.children.push(node);
                        return node;
                    } else{
                        return this.addNodeByCategoryId(category.CAT_PARENT_ID,tree);
                    }
                }           
                
            },
                
            addNodeToGridItems(node,data,indent){
                let row = { id : node.id,
                            text: node.categoryName,                                    
                            indent : indent,
                            amount: this.formatCurrency(node.amount),
                        }
                if(node.isTransaction){
                     row.text= node.transaction.TRA_TEXT;
                     row.amount= this.formatCurrency(node.transaction.TRA_AMOUNT);
                     row.isTransaction = true;
                     row.transaction = node.transaction;
                     row.date = moment(node.transaction.TRA_DATE).format('ll');
                }
                data.push(row);                    
                if(this.expandedCategories[node.id]){
                    node.children.map(childNode=>{
                        this.addNodeToGridItems(childNode,data,indent+1);                            
                    });
                }

            },   
                
            addTransactionToTree(transaction,tree){
                let categories = this.getCategoryLineup(transaction.TRA_CAT_ID);
                for (let index = 0; index < categories.length; index++) {
                    const category = categories[index];
                    let node = this.findNodeByCategoryId(category.CAT_ID,tree); 
                    if(!node){
                        node = this.addNodeByCategoryId(category.CAT_ID,tree);
                    }
                    if(index==categories.length-1 && node){
                        node.children.push({
                                id: 't_'+transaction.TRA_ID,
                                name: this.formatCurrency(transaction.TRA_AMOUNT)+' '+moment(transaction.TRA_DATE).format('ll')+' '+ transaction.TRA_TEXT,                                                        
                                isTransaction:true,
                                transaction : transaction,                                
                            });                   
                    }
                    
                }
                 

                
                
            },

            expand(rowData){
                rowData.isExpanded = !rowData.isExpanded;
            },

            findNodeByCategoryId(catId,tree){
                for (let index = 0; index < tree.length; index++) { 
                    const node = tree[index];    
                    if(node.id == catId){
                        return node;
                    } else{
                        if(node.children && node.children.length>0){
                            let childNode = this.findNodeByCategoryId(catId,node.children);
                            if(childNode){
                                return childNode;
                            }
                        }
                    }
                }
                return null;
            },

            findTransactionForCategory(category,transactions){
                let result = [];
                transactions.map(trans=>{
                    if(this.isChildOrCategory(trans.TRA_CAT_ID,category)){
                        result.push({
                            'name': this.formatCurrency(trans.TRA_AMOUNT)+' '
                                    +GatUtils.lookupCode(trans.TRA_CAT_ID,this.$store.state.categories,"CAT_ID","fullName")+' '+
                                    trans.TRA_TEXT,
                        });
                    }
                });
                return result;
            },

            findUsedRootCateories(transactions){
                let result = [];
                transactions.map(trans=>{
                    let category = this.getCategoryFromId(trans.TRA_CAT_ID);
                    if(category){
                        if(category.CAT_PARENT_ID != null){
                            category = this.getRootCategory(category);
                        } 
                        if (!result.some(item => item.CAT_ID === category.CAT_ID)) {   
                            result.push(category);                     
                        }
                    }
                })
                return result.sort((a,b)=>{
                    return a.CAT_SORT - b.CAT_SORT;
                });
            },

            formatCurrency(amount){
                return new Intl.NumberFormat('no-NO', { style: 'currency', currency: 'NOK' }).format(amount) 
            },

            getAmountForCategory(category,transactions){
                let catTrans  = transactions.filter(trans=>{
                    return this.isChildOrCategory(trans.TRA_CAT_ID,category);
                })

                let result = 0;
                catTrans.map(trans=>{
                    result = result+trans.TRA_AMOUNT;
                });
                return result;
            },

            getCategoryFromId(catId){                 
                let result = this.$store.state.categories.find(item=>{
                    return item.CAT_ID == catId;
                })
                if(result){
                    return result;
                } else{
                    return null;
                }                
            },

            getCategoryLineup(catId){
                let result = [];
                let category = this.getCategoryFromId(catId);
                if(category){
                    result.push(category);
                }
                while (category && category.CAT_PARENT_ID) {                   
                    category = this.getCategoryFromId(category.CAT_PARENT_ID);
                    if(category){
                       result.push(category);
                    }
                }
                return result.reverse();
            },

            getRootCategory(childCategory){
                if(childCategory.CAT_PARENT_ID == null){
                    return childCategory;
                } 

                let parentCatory = this.getCategoryFromId(childCategory.CAT_PARENT_ID);
                if(parentCatory){
                    return this.getRootCategory(parentCatory);
                }
            },

            makeTreeNode(category){
                let amount = this.getAmountForCategory(category,this.value);
                return {
                    id:category.CAT_ID,            
                    name:category.CAT_NAME+' : '+this.formatCurrency(amount),
                    categoryName : category.CAT_NAME,
                    amount: amount,
                    children:[], 
                }
            },

            manage(trans){
               let newTrans = GatUtils.makeCopyViaJson(trans);
               this.$store.state.newTransactions.push(newTrans);
            },

             isChildOrCategory(catId,category){
                 if(category.CAT_ID == catId){
                     return true;
                 }
                 let childCategory = this.getCategoryFromId(catId);

                if(childCategory){                
                    if(childCategory.CAT_PARENT_ID == category.CAT_ID){
                        return true
                    }

                    if(childCategory.CAT_PARENT_ID == null){
                        return false;
                    } else{
                        return this.isChildOrCategory(childCategory.CAT_PARENT_ID,category);
                    }
                } else {
                    return false;
                }

                 

             },
        },
    }
</script>

<style scoped>
    .gridCategory{
        vertical-align: middle;
        margin-top: 13px;
        margin-bottom: -13px;
    }
    .indent_1{
        margin-left: 30px;
    }
    .indent_2{
        margin-left: 60px;
    }
    .indent_3{
        margin-left: 90px;
    }
    .indent_4{
        margin-left: 120px;
    }
    .indent_5{
        margin-left: 150px;
    }
</style>
